import React, { Component } from 'react';

import JackpotKiosk from "../pages/JackpotKiosk";
import MSLogin from "../pages/MSLogin";
import Login from "../pages/Login";

class PublicRoute extends Component {
    render() {
        const { location, cookies, history, settings, userAuthenticated } = this.props;
        return (
            <>
                {location.pathname === "/jackpot"
                    ? <JackpotKiosk location={location} defaultJackpotId={settings ? settings.general.default_jackpot_id : 0} />
                    : location.pathname === "/letsgo"
                    ? <MSLogin cookies={cookies} history={history} />
                    : !userAuthenticated && <Login cookies={cookies} history={history} userAuthenticated={userAuthenticated} />
                }
            </>
        );
    }
}

export default PublicRoute;
